import React from "react";
import Slider from "../components/Slidbar/Slidbar";
import Tabel from "../components/AdminNotes/Table";

export const AdminNotes = () => {
  return (
    <>
      <Slider />
      <Tabel />
    </>
  );
};
